module.exports = __webpack_public_path__ + "static/media/ss2.a3cf9645.jpg";